import { useParams } from "@solidjs/router";
import { EvalBatchDetail } from "./EvalBatchDetail";
import { EvalComparisonDetail } from "./EvalComparisonDetail";
import { EvalSuiteDetail } from "./EvalSuiteDetail";

/**
 * Param-reading shells for the eval routes, matching `features/govern`'s
 * `GovernRoute`. `useParams()` runs once at component setup here, so the
 * screens stay prop-driven — and `App.tsx` stays a route table rather than a
 * pile of inline param plumbing.
 */

export function EvalSuiteRoute() {
  const params = useParams();
  return <EvalSuiteDetail suiteId={params.id ?? ""} />;
}

export function EvalBatchRoute() {
  const params = useParams();
  return <EvalBatchDetail batchId={params.id ?? ""} />;
}

export function EvalComparisonRoute() {
  const params = useParams();
  return <EvalComparisonDetail comparisonId={params.id ?? ""} />;
}
